function animateRow(row) {
  row.classList.add('show');
}
const rows = document.querySelectorAll('.trigger');
const trigger = new IntersectionObserver((entries, trigger) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      animateRow(entry.target);
      trigger.unobserve(entry.target);
    }
  });
}, {
  threshold: 0.1
});

rows.forEach(row => {
  trigger.observe(row);
});